module.exports = __webpack_public_path__ + "img/yiren.ac1a34fd.png";